// extracted by mini-css-extract-plugin
export var deleteIcon = "_re-5";
export var deleteOption = "_re-3";
export var divider = "_re-2";
export var downloadIcon = "_re-4";
export var drawer = "_re-0";
export var drawerFooter = "_re-6";
export var drawerOpen = "_re-1";
export var highlighted = "_re-7";
export var lighterHighlight = "_re-8";